export enum ReportType {
  IOSS = 1,
  OSS,
  Regular,
  UK,
    Purchases
}
